import React from "react";

// Libs
import { ReactFlowProvider } from '@xyflow/react';

// Components
import { FlowChart } from "./ReactFlow";
import { Header } from "~/components/Header";
import { Sidebar } from "~/components/Sidebar";
import { InteractiveStage } from "~/components/Stage";
import { AvatarPanel } from "~/components/AvatarPanel";

// Contexts
import { ModalProvider } from "~/contexts/ModalContext";
import { useTheme } from "~/contexts/ThemeContext";
import { DevModeProvider } from "~/contexts/DevModeContext";

// Styles
import "~/styles/Genia.css"

export const Genia = () => {
    const { sidebarCollapsed } = useTheme();

    return (
        <DevModeProvider>
            <ModalProvider>
                <ReactFlowProvider>
                    <div className="genia-app">
                        <Header />
                        <div className="app-central">
                            <Sidebar />
                            <FlowChart isCollapsed={sidebarCollapsed} />
                            <div className="app-right-panel">
                                <InteractiveStage />
                                <AvatarPanel />
                            </div>
                        </div>
                    </div>
                </ReactFlowProvider>
            </ModalProvider>
        </DevModeProvider>
    );
};
